module.exports = __webpack_public_path__ + "static/media/tvgybhcuop.d61adddd.png";